import { Box, Typography } from '@mui/material';

import { zIndexes } from '@/styles/zIndexes';

export interface DebugAnnotationInfoProps {
  left: number;
  top: number;
  width: number;
  height: number;
  originalCoords: { x: number; y: number }[];
  pageOffset: number;
  viewport: { width: number; height: number };
}

export function DebugAnnotationInfo({
  left,
  top,
  width,
  height,
  originalCoords,
  pageOffset,
  viewport,
}: DebugAnnotationInfoProps) {
  const minOrigY = Math.min(...originalCoords.map((c) => c.y));
  const scaledY = minOrigY * (viewport.height / 11);

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '100%',
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        color: 'white',
        padding: '2px 4px',
        fontSize: '10px',
        whiteSpace: 'nowrap',
        zIndex: zIndexes.HIGHLIGHT + 1,
        pointerEvents: 'none',
        marginTop: '2px',
        maxWidth: '300px',
      }}
    >
      <Typography variant="body-xs" component="pre" sx={{ fontSize: '10px' }}>
        {`pos(${left.toFixed(0)},${top.toFixed(0)}) size(${width.toFixed(0)}×${height.toFixed(0)})
orig_y:${minOrigY.toFixed(2)} scaled:${scaledY.toFixed(0)} offset:${pageOffset.toFixed(0)}`}
      </Typography>
    </Box>
  );
}
